/* ============================================================================
   Boho Classic Bell Tent PDP — behaviour (multi-section)
   One controller wires the buy box together with the (now separate) fabric
   table, size visualiser and weight calculator. It uses document-wide queries
   + event delegation, so those tool sections can be reordered freely in the
   theme editor and still stay in sync with the buy-box size/canvas selection.
   Reads config from the first inline [data-bt-config] JSON on the page.
   ============================================================================ */
(function () {
  "use strict";
  if (window.__btPdpBooted) return;
  window.__btPdpBooted = true;

  var USER = '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="7.5" r="3.5"/><path d="M5 20v-1a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v1"/></svg>';
  var CHECK = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12l5 5L20 6"/></svg>';
  var RULER = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="8" width="20" height="8" rx="1.5"/><path d="M6 8v3m4-3v4m4-4v3m4-3v4"/></svg>';

  var $ = function (s) { return document.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(document.querySelectorAll(s)); };

  // ---- shared state + config ----
  var cfg, variants = [], fabrics = [], sizes = [], weights = {};
  var fabByVal = {}, sizeByVal = {}, heroSize = {};
  var state = { size: null, material: null }, qty = 1, szView = null, wc = { size: null, material: null };
  var galMain = null, thumbEls = [], thumbsBox = null, moreBtn = null, dispEl = null, dispTimer = null;
  var prot = null, protSel = "none", protColour = "Beige";

  var STOVE_RE = /(DSC5696edited|ClassicBellTent4|CampingStove)/i;
  var FABRICS = [
    { file: /oxford/i,            mat: /oxford/i },
    { file: /fire[_ -]?cotton/i,  mat: /fire cotton/i },
    { file: /poly[_ -]?cotton/i,  mat: /poly/i },
    { file: /pure[_ -]?cotton/i,  mat: /pure cotton/i }
  ];

  function money(p) {
    var n = (p || 0) / 100;
    return "£" + n.toLocaleString("en-GB", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function variantFor(size, mat) {
    return variants.find(function (v) { return v.size === size && v.material === mat; }) || null;
  }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function firstVal(o) { for (var k in o) return o[k]; return null; }

  // ---- protection picker (size-matched accessory add-on) ----
  function protTier(v) { if (!prot) return null; for (var i = 0; i < prot.tiers.length; i++) if (prot.tiers[i].v === v) return prot.tiers[i]; return null; }
  // resolve a purchasable record for a tier at the current colour, falling back
  // to any in-stock colour; sold-out variants are treated as absent
  function protRec(t, bySize) {
    if (!bySize) return null;
    if (t && t.hasColour) {
      var rec = bySize[protColour];
      if (rec && rec.available) return rec;
      for (var k in bySize) if (bySize[k] && bySize[k].available) return bySize[k];
      return null;
    }
    var g = bySize["_"];
    return (g && g.available) ? g : null;
  }
  function availTiers(sz) {
    if (!prot) return [];
    return prot.tiers.filter(function (t) { var m = prot.map[t.v]; return m && protRec(t, m[sz]); });
  }
  // resolve the variant record for the current selection (tier + size + colour)
  function addonInfo() {
    if (!prot || protSel === "none") return null;
    var m = prot.map[protSel]; if (!m) return null;
    return protRec(protTier(protSel), m[state.size]);
  }
  function addonPrice() { var a = addonInfo(); return a ? a.price : 0; }

  function protTierHtml(t, sz, base) {
    var active = protSel === t.v;
    var priceHtml, saveHtml = "";
    if (t.v === "none") {
      priceHtml = money(base);
    } else {
      var bySize = prot.map[t.v][sz];
      var rec = protRec(t, bySize);
      priceHtml = "+" + money(rec.price);
      if (rec.ref && rec.ref > rec.price) saveHtml = '<small class="pick__save">save ' + money(rec.ref - rec.price) + "</small>";
    }
    var colourHtml = "";
    if (active && t.hasColour) {
      var SW = { "Beige": "#D8C4A2", "Silver/Black": "linear-gradient(135deg,#cfcfcf 0 50%,#1c1c1c 50% 100%)" };
      colourHtml = '<span class="pick__colours" data-bt-prot-colours>' +
        '<span class="pick__colours-lbl">Cover colour</span>' +
        prot.colours.map(function (c) {
          var has = prot.map[t.v][sz][c] && prot.map[t.v][sz][c].available;
          return '<button type="button" class="pick__col' + (protColour === c ? " active" : "") + '"' + (has ? "" : " disabled") + ' data-bt-prot-colour="' + esc(c) + '">' +
            '<span class="pick__sw" style="background:' + (SW[c] || "#ccc") + '"></span>' + esc(c) + "</button>";
        }).join("") + "</span>";
    }
    return '<div class="pick' + (active ? " active" : "") + (t.popular ? " featured" : "") + '" role="button" tabindex="0" data-bt-prot-tier="' + esc(t.v) + '">' +
      '<span class="pick__radio"></span>' +
      '<span class="pick__body">' +
        '<span class="pick__title">' + (t.lead ? esc(t.lead) + " " : "") + esc(t.title) + (t.popular ? '<i class="pick__tag">Most popular</i>' : "") + "</span>" +
        '<span class="pick__desc">' + esc(t.desc) + "</span>" + colourHtml +
      "</span>" +
      '<span class="pick__price">' + priceHtml + saveHtml + "</span>" +
    "</div>";
  }
  function protectRender() {
    var root = $("[data-bt-protect]"); if (!root) return;
    if (!prot || !prot.show) { root.hidden = true; protSel = "none"; return; }
    var sz = state.size;
    var avail = availTiers(sz);
    if (!avail.length) { root.hidden = true; protSel = "none"; return; }
    root.hidden = false;
    // if the current add-on isn't offered for this size, drop back to tent-only
    if (protSel !== "none" && !avail.some(function (t) { return t.v === protSel; })) protSel = "none";
    // snap the colour to an in-stock option for the selected tier
    if (protSel !== "none") {
      var tSel = protTier(protSel);
      if (tSel && tSel.hasColour) {
        var bs = prot.map[protSel][sz];
        if (bs && !(bs[protColour] && bs[protColour].available)) {
          for (var k in bs) if (bs[k] && bs[k].available) { protColour = k; break; }
        }
      }
    }
    var list = $("[data-bt-protect-list]"); if (!list) return;
    var base = (variantFor(sz, state.material) || {}).price || 0;
    var html = protTierHtml({ v: "none", title: "Tent only", desc: "Just the bell tent." }, sz, base);
    avail.forEach(function (t) { html += protTierHtml(t, sz, base); });
    list.innerHTML = html;
  }
  // Add to cart then open the THEME's native cart drawer (unchanged). The
  // Concept <cart-drawer> listens on document for "cart:refresh" and opens when
  // detail.open === true. We only fire the event the theme already uses.
  function btAddToCart(payload, fallback) {
    if (!window.fetch) { if (fallback) fallback(); return; }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { if (fallback) fallback(); return; }
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { open: true } }));
      })
      .catch(function () { if (fallback) fallback(); });
  }
  function stoveLabel(s) { return s === "flap" ? "Stove-safe · flap included" : s === "noflap" ? "Stove-compatible" : "Not stove-compatible"; }
  function fileOf(url) { return (url || "").split("?")[0].split("/").pop(); }
  function isFireCotton() { return /fire cotton/i.test(state.material || ""); }
  function fabricMat(file) {
    for (var i = 0; i < FABRICS.length; i++) if (FABRICS[i].file.test(file)) return FABRICS[i].mat;
    return null;
  }
  function imgSize(url, alt) {
    var m = (alt || "").match(/#size_(\d+m)\b/i);
    if (m) return m[1].toLowerCase();
    return heroSize[url] || null;
  }

  // ---- buy box render (also drives the fabric table + sticky mirror) ----
  function render() {
    var v = variantFor(state.size, state.material);
    var fm = fabByVal[state.material] || {};
    var price = v ? v.price : 0;
    var soldOut = !v || !v.available;

    var pe = $('[data-bt-price]'); if (pe) pe.textContent = money(price);
    var cmp = v ? (v.compare || 0) : 0;
    var onSale = cmp > price && !soldOut;
    if (pe) pe.classList.toggle("is-sale", onSale);
    var was = $('[data-bt-was]');
    if (was) { was.hidden = !onSale; was.textContent = onSale ? money(cmp) : ""; }
    var save = $('[data-bt-save]');
    if (save) { save.hidden = !onSale; save.textContent = onSale ? "Save " + money(cmp - price) : ""; }
    var ends = $('[data-bt-ends]');
    var saleFlag = $('[data-bt-sale-flag]');
    var saleEnd = new Date(2026, 7, 31, 23, 59, 59); // 31 Aug 2026, local time
    var daysLeft = Math.ceil((saleEnd - new Date()) / 86400000);
    var saleOver = daysLeft < 0;
    if (ends) {
      ends.hidden = !onSale || saleOver;
      var tailEl = ends.querySelector('[data-bt-ends-tail]');
      if (tailEl && !saleOver) {
        var tail = daysLeft > 1 ? daysLeft + " days left" : (daysLeft === 1 ? "ends tomorrow" : "ends today");
        tailEl.textContent = "until 31 August · " + tail;
      }
    }
    if (saleFlag) saleFlag.hidden = !onSale || saleOver;
    var note = $('[data-bt-note]'); if (note) note.textContent = state.size + " · " + (fm.short || state.material) + " " + (fm.gsm || "");

    $$('[data-bt-size]').forEach(function (b) { b.classList.toggle("active", b.getAttribute("data-bt-size") === state.size); });

    $$('[data-bt-fab]').forEach(function (b) {
      var mat = b.getAttribute("data-bt-fab");
      b.classList.toggle("active", mat === state.material);
      var fv = variantFor(state.size, mat);
      var pr = b.querySelector('[data-bt-fab-price]');
      if (pr) pr.innerHTML = (!fv || !fv.available) ? '<i class="tfab__out">Sold out</i>' : money(fv.price);
      b.classList.toggle("out", !fv || !fv.available);
    });

    var stove = $('[data-bt-stove]');
    if (stove) stove.innerHTML = "<b>" + (fm.short || state.material) + ":</b> " + (fm.blurb || "") +
      ' <span class="tstove ' + (fm.stove === "no" ? "no" : "yes") + '">' + stoveLabel(fm.stove) + "</span>";

    var dot = $('[data-bt-stock-dot]'), st = $('[data-bt-stock-text]');
    if (dot && st) {
      if (soldOut) { st.textContent = "This combination is sold out — try another canvas or size."; dot.classList.add("low"); }
      else { var inv = v.inventory; var low = inv != null && inv > 0 && inv <= 6;
        st.textContent = low ? "Low stock — only " + inv + " left" : "In stock, ready to ship"; dot.classList.toggle("low", low); }
    }

    var fill = $('[data-bt-ship-fill]'); if (fill) fill.style.width = "100%";
    protectRender();
    var add = $('[data-bt-add]'), idIn = $('[data-bt-variant-id]');
    if (idIn && v) idIn.value = v.id;
    if (add) {
      if (soldOut) { add.disabled = true; add.textContent = "Sold out"; }
      else { add.disabled = false; add.textContent = "Add to basket — " + money(price * qty + addonPrice()); }
    }
    var checkout = $('[data-bt-checkout]'); if (checkout) checkout.style.display = soldOut ? "none" : "";

    // fabric table active column (separate section — found document-wide)
    $$('[data-bt-fc-head]').forEach(function (h) { h.classList.toggle("active", h.getAttribute("data-bt-fc-head") === state.material); });
    $$('[data-bt-fc-cell]').forEach(function (c) { c.classList.toggle("active", c.getAttribute("data-bt-fc-cell") === state.material); });
    $$('[data-bt-fc-pick]').forEach(function (p) {
      var on = p.getAttribute("data-bt-fc-pick") === state.material;
      p.classList.toggle("on", on); p.textContent = on ? "Selected" : "Select";
    });

    $$('[data-bt-sticky-price]').forEach(function (e) { e.textContent = money(price); });
    $$('[data-bt-sticky-var]').forEach(function (e) { e.textContent = state.size + " · " + (fm.short || state.material); });
    var sBtn = $('[data-bt-add-trigger]'); if (sBtn) { sBtn.disabled = soldOut; sBtn.textContent = soldOut ? "Sold out" : "Add to basket"; }

    // weight calc mirrors the buy-box selection (one-way: it follows, but its own
    // controls never write back to the tent).
    wc.size = state.size; wc.material = state.material; renderWeight();

    updateOSM(v);
    renderGallery();
  }

  // Klarna + Clearpay on-site messaging don't see our custom variant switch. Both
  // app blocks watch (via PerformanceObserver) for a Section-Rendering request that
  // carries a ?variant= param, then update their placement from that variant. We
  // replicate that fetch (debounced); plus directly set the Square <square-placement>
  // data-amount (pounds) as a belt-and-braces fallback.
  function updateOSM(v) {
    if (!v) return;
    // Clearpay app block renders a <square-placement> that reads data-amount (pounds)
    document.querySelectorAll('square-placement[data-amount]').forEach(function (s) { s.setAttribute('data-amount', (v.price / 100).toString()); });
    // Klarna's app-block SDK reads the selected variant from the URL ?variant= param,
    // so reflect the selection there (keeping other params) then trigger its refresh.
    try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
    try { (window.KlarnaOnsiteService = window.KlarnaOnsiteService || []).push({}); } catch (e) {}
  }

  // ---- gallery (size + fabric + stove image filters) ----
  function setMain(url) {
    if (galMain && url) galMain.style.backgroundImage = "url(" + url + ")";
    thumbEls.forEach(function (t) { t.classList.toggle("active", t.style.display !== "none" && t.getAttribute("data-img") === url); });
  }
  function renderGallery() {
    if (!thumbEls.length) return;
    var firstVisible = null;
    thumbEls.forEach(function (t) {
      var url = t.getAttribute("data-img"), file = fileOf(url);
      var sz = imgSize(url, t.getAttribute("data-alt"));
      var fab = fabricMat(file);
      var show = (!sz || sz === state.size)
              && (!fab || fab.test(state.material || ""))
              && (!STOVE_RE.test(file) || isFireCotton());
      t.style.display = show ? "" : "none";
      if (show && !firstVisible) firstVisible = t;
    });
    var v = variantFor(state.size, state.material);
    setMain((v && v.image) ? v.image : (firstVisible ? firstVisible.getAttribute("data-img") : null));
    updateMore();
  }
  function updateMore() {
    if (!thumbsBox || !moreBtn) return;
    var more = thumbsBox.scrollHeight - thumbsBox.clientHeight > 4
            && thumbsBox.scrollTop + thumbsBox.clientHeight < thumbsBox.scrollHeight - 4;
    moreBtn.classList.toggle("is-active", more);
  }

  // ---- size visualiser ----
  function renderSize() {
    var s = sizeByVal[szView] || sizes[0]; if (!s) return;
    $$('[data-bt-sz-tab]').forEach(function (t) { t.classList.toggle("active", t.getAttribute("data-bt-sz-tab") === szView); });
    var set = function (sel, html, isText) { var e = $(sel); if (!e) return; if (isText) e.textContent = html; else e.innerHTML = html; };
    var img = $('[data-bt-sz-img]'); if (img) img.style.backgroundImage = "url(" + s.img + ")";
    set('[data-bt-sz-tag]', s.tag, true);
    set('[data-bt-sz-dims]', RULER + " " + s.dims);
    set('[data-bt-sz-cap]', s.cap, true);
    var people = Math.min(s.people, 10);
    set('[data-bt-sz-people]', new Array(people + 1).join(USER) + (s.people > 10 ? '<span class="sz-people__plus">+</span>' : ""));
    set('[data-bt-sz-desc]', s.desc, true);
    set('[data-bt-sz-fits]', (s.fits || []).map(function (f) { return '<span class="sz-chip">' + CHECK + " " + f + "</span>"; }).join(""));
    set('[data-bt-sz-best]', "<b>Best for:</b> " + s.best);
    var choose = $('[data-bt-sz-choose]'); if (choose) choose.textContent = "Choose " + szView + " →";
  }

  // ---- weight calculator ----
  function band(kg) {
    if (kg < 20) return { lab: "Light — comfortable one-person carry", pct: 22 };
    if (kg < 35) return { lab: "Moderate — easy two-person lift", pct: 45 };
    if (kg < 55) return { lab: "Heavy — best carried by two", pct: 72 };
    return { lab: "Very heavy — a sack truck helps", pct: 95 };
  }
  function renderWeight() {
    var kg = weights[wc.size + "|" + wc.material];
    var b = band(kg || 0); var fm = fabByVal[wc.material] || {};
    $$('[data-bt-wc-size]').forEach(function (x) { x.classList.toggle("active", x.getAttribute("data-bt-wc-size") === wc.size); });
    $$('[data-bt-wc-fab]').forEach(function (x) { x.classList.toggle("active", x.getAttribute("data-bt-wc-fab") === wc.material); });
    var kgEl = $('[data-bt-wc-kg]'); if (kgEl) kgEl.innerHTML = (kg != null ? kg : "—") + "<small>kg</small>";
    var bar = $('[data-bt-wc-bar]'); if (bar) bar.style.width = b.pct + "%";
    var bandEl = $('[data-bt-wc-band]'); if (bandEl) bandEl.textContent = b.lab;
    var sub = $('[data-bt-wc-sub]'); if (sub) sub.textContent = wc.size + " · " + (fm.short || wc.material) + " " + (fm.gsm || "") + ", including poles, pegs & bag";
  }

  // ---- jump to a tool section by id ----
  function jump(target) {
    var el = document.getElementById('sec-' + target);
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: "smooth" });
  }

  // ---- dispatch countdown ----
  var ord = function (n) { var s = ["th","st","nd","rd"], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); };
  var fmtLong = function (d) { return d.toLocaleDateString("en-GB", { weekday: "long" }) + ", " + ord(d.getDate()) + " " + d.toLocaleDateString("en-GB", { month: "long" }); };
  var nextWorkday = function (d) { while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1); return d; };
  var addWorkdays = function (d, n) { var a = 0; while (a < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) a++; } return d; };
  function tick() {
    if (!dispEl) return;
    var now = new Date(); var target = new Date(); target.setHours(12, 0, 0, 0);
    if (now >= target) target.setDate(target.getDate() + 1);
    var diff = Math.max(0, Math.floor((target - now) / 1000));
    var h = Math.floor(diff / 3600), m = Math.floor((diff % 3600) / 60);
    var dispatch = nextWorkday(new Date(target));
    var delivery = addWorkdays(new Date(dispatch), 2);
    dispEl.innerHTML = 'Order within <b class="treassure__count--inline">' + h + ' Hrs ' + m + ' Mins</b> for delivery by <b>' + fmtLong(delivery) + '</b>';
  }

  // ---- sticky bar on scroll ----
  function onScroll() {
    var sticky = $('[data-bt-sticky]'), buyRef = $('[data-bt-buyref]');
    if (!sticky || !buyRef) return;
    var r = buyRef.getBoundingClientRect();
    var nearBottom = window.innerHeight + window.scrollY > document.body.scrollHeight - 260;
    sticky.classList.toggle("show", r.bottom < 40 && !nearBottom);
  }

  // ---- reveal-on-scroll (visible by default; fade only while JS runs) ----
  var io = null;
  function reveal() {
    var reveals = $$("[data-reveal]"); if (!reveals.length) return;
    $$("[data-bohotent]").forEach(function (w) { if (w.querySelector("[data-reveal]")) w.classList.add("is-revealing"); });
    var revealAll = function () { reveals.forEach(function (el) { el.classList.add("in"); }); };
    if (!("IntersectionObserver" in window)) { revealAll(); return; }
    if (!io) io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } }); }, { threshold: 0.08, rootMargin: "0px 0px -5% 0px" });
    reveals.forEach(function (el) { if (el.classList.contains("in")) return; var r = el.getBoundingClientRect(); if (r.top < window.innerHeight) el.classList.add("in"); else io.observe(el); });
    setTimeout(revealAll, 1500);
  }

  // ---- single delegated click handler (order/section-load independent) ----
  function onClick(e) {
    var t;
    if ((t = e.target.closest('[data-bt-prot-colour]'))) { if (t.disabled) return; protColour = t.getAttribute("data-bt-prot-colour"); render(); return; }
    if ((t = e.target.closest('[data-bt-prot-tier]')))   { protSel = t.getAttribute("data-bt-prot-tier"); render(); return; }
    if ((t = e.target.closest('[data-bt-size]')))         { state.size = t.getAttribute("data-bt-size"); render(); return; }
    if ((t = e.target.closest('[data-bt-fab]')))          { state.material = t.getAttribute("data-bt-fab"); render(); return; }
    if ((t = e.target.closest('[data-bt-fc-pick]')))      { state.material = t.getAttribute("data-bt-fc-pick"); render(); jump("fabrics"); return; }
    if ((t = e.target.closest('[data-bt-thumb]')))        { setMain(t.getAttribute("data-img")); return; }
    if ((t = e.target.closest('[data-bt-thumbs-more]')))  { if (thumbsBox) thumbsBox.scrollBy({ top: thumbsBox.clientHeight * 0.8, behavior: "smooth" }); return; }
    if ((t = e.target.closest('[data-bt-qty]')))          { qty = Math.max(1, qty + parseInt(t.getAttribute("data-bt-qty"), 10)); var d = $('[data-bt-qty-val]'); if (d) d.textContent = qty; var qi = $('[data-bt-qty-input]'); if (qi) qi.value = qty; render(); return; }
    if ((t = e.target.closest('[data-bt-add-trigger]')))  { e.preventDefault(); var f = $('[data-bt-form]'); if (f && f.requestSubmit) f.requestSubmit(); else if (f) f.submit(); return; }
    if ((t = e.target.closest('[data-bt-accord-head]')))  { var row = t.parentElement; var openNow = row.classList.contains("open"); $$('[data-bt-accord]').forEach(function (r) { r.classList.remove("open"); }); row.classList.toggle("open", !openNow); return; }
    if ((t = e.target.closest('[data-bt-jump]')))         { jump(t.getAttribute("data-bt-jump")); return; }
    if ((t = e.target.closest('[data-bt-sz-tab]')))       { szView = t.getAttribute("data-bt-sz-tab"); renderSize(); return; }
    if ((t = e.target.closest('[data-bt-sz-choose]')))    { state.size = szView; render(); jump("sizes"); return; }
    if ((t = e.target.closest('[data-bt-wc-size]')))      { wc.size = t.getAttribute("data-bt-wc-size"); renderWeight(); return; }
    if ((t = e.target.closest('[data-bt-wc-fab]')))       { wc.material = t.getAttribute("data-bt-wc-fab"); renderWeight(); return; }
  }

  // re-grab the elements that are queried once (gallery lives in the main section)
  function grab() {
    galMain = $('[data-bt-gallery-main]');
    thumbEls = $$('[data-bt-thumb]');
    var nb = $('[data-bt-thumbs]');
    if (nb && nb !== thumbsBox) { thumbsBox = nb; thumbsBox.addEventListener("scroll", updateMore, { passive: true }); }
    moreBtn = $('[data-bt-thumbs-more]');
    var de = $('[data-bt-dispatch]');
    if (de && de !== dispEl) { dispEl = de; tick(); if (!dispTimer) dispTimer = setInterval(tick, 1000); }
  }

  function refresh() { grab(); render(); renderSize(); renderWeight(); reveal(); }

  function boot() {
    var cfgEl = $('[data-bt-config]'); if (!cfgEl) return;
    try {
      cfg = JSON.parse(cfgEl.textContent);
      variants = cfg.variants || []; fabrics = cfg.fabrics || []; sizes = cfg.sizes || []; weights = cfg.weights || {};
      prot = cfg.protection || null;
      if (prot) { protColour = prot.defaultColour || "Beige"; protSel = prot.default || "none"; }
      fabByVal = {}; fabrics.forEach(function (f) { fabByVal[f.value] = f; });
      sizeByVal = {}; sizes.forEach(function (s) { sizeByVal[s.value] = s; });
      // size visualiser data is editable in its own section — if present, it overrides the defaults
      var szEl = document.querySelector('[data-bt-sizecfg]');
      if (szEl) { try {
        var sc = JSON.parse(szEl.textContent);
        if (sc && sc.length) {
          sizes = sc.map(function (o) { o.fits = (o.fitsStr || "").split(/\s*,\s*/).filter(Boolean); o.people = +o.people || 0; return o; });
          sizeByVal = {}; sizes.forEach(function (z) { sizeByVal[z.value] = z; });
        }
      } catch (e) {} }
      heroSize = {}; variants.forEach(function (v) { if (v.image && !(v.image in heroSize)) heroSize[v.image] = v.size; });

      var sel = cfg.selected || {};
      var startV = (sel.size && variantFor(sel.size, sel.material))
        || variants.find(function (v) { return v.size === "5m" && v.available; })
        || variants.find(function (v) { return v.available; }) || variants[0] || {};
      state = { size: startV.size, material: startV.material };
      szView = state.size; wc = { size: state.size, material: state.material };

      document.addEventListener("click", onClick);
      // intercept the buy-box form submit (and the sticky's requestSubmit) so
      // add-to-cart opens the native drawer instead of navigating to /cart.
      // Shop Pay's dynamic-checkout button is not a form submit, so it is left
      // on its own native flow.
      document.addEventListener("submit", function (e) {
        var f = e.target.closest && e.target.closest('[data-bt-form]');
        if (!f) return;
        e.preventDefault();
        var v = variantFor(state.size, state.material);
        if (!v || !v.available) return;
        var items = [{ id: v.id, quantity: qty }];
        var a = addonInfo();
        if (a && a.id) items.push({ id: a.id, quantity: 1 });
        btAddToCart({ items: items }, function () { f.submit(); });
      });
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", updateMore);

      grab();
      reveal();
      render(); renderSize(); renderWeight();
      onScroll();
    } catch (err) {
      $$("[data-bohotent]").forEach(function (w) { w.classList.remove("is-revealing"); });
      $$("[data-reveal]").forEach(function (el) { el.classList.add("in"); });
      if (window.console) console.error("[bohotent] init failed:", err);
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  // theme editor: re-sync when a section is added / reordered
  document.addEventListener("shopify:section:load", function () { try { refresh(); } catch (e) {} });
})();
